<template>
  <div class="lottery-container">
    <img
      class="bg-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/045bb6ae64d387465b8d225ab79ca2ea_wh=1125_726.png"
      alt=""
    />
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <!-- <div class="coach-container" v-if="activityInfo.activity_crowd == 1">
      <img
        class="coach-avatar"
        src="https://wegymercdn.gymcity.com.cn/coach_archives_3.0/c388a72c8d990d40e950b01c9fd29217.jpg"
        alt=""
      />
      <div class="coach-info">
        <div class="name">罗明阳</div>
        <div class="desc">收到小红花，心里乐开花！</div>
        <div class="text">感谢你对我的肯定～</div>
      </div>
    </div> -->
    <div class="result" v-if="lotteryData">
      <img
        class="title-image"
        v-if="activityInfo.activity_crowd == 1"
        src="https://btw-common-data.betterwestar.com/btw-admin/resource/2d1cd114d461de06d769d01e33d3d67f_wh=489_114.png"
        alt=""
      />
      <img
        v-else
        class="title-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/resource/b8936950ea72e9c2ea4d65c9cf145f98_wh=609_114.png"
        alt=""
      />
      <div class="name">{{ lotteryData.reward_name }}</div>
      <img class="image" :src="lotteryData.reward_image" alt="" />
    </div>
    <div class="tips" v-if="lotteryData.reward_describe">{{
      lotteryData.reward_describe
    }}</div>
    <div class="confirm-btn" @click="bindConfirm">{{
      activityInfo.activity_crowd == 1 ? '知道啦' : '领取'
    }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    },
    lotteryData() {
      return this.$store.state.coachActivity2024.lotteryPage.lotteryData
    }
  },
  created() {},
  methods: {
    bindConfirm() {
      if (this.activityInfo.activity_crowd == 2) {
        this.$http.addDataLog({
          eventk: 'CLICK_huodong_COACH_xhh_tyk',
          eventv: ''
        })
        setTimeout(() => {
          location.href =
            'https://work.weixin.qq.com/ca/cawcdee55662b9cd58?customer_channel=qywx_ca:107940455'
        }, 400)
      } else {
        this.$emit('close')
      }
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.lottery-container {
  position: relative;
  z-index: 1;
  background: linear-gradient(178deg, #ffc0dc 0%, #fff3f8 100%);
  border-radius: 8px 8px 0px 0px;
  padding: 94px 12px 38px;
  box-sizing: border-box;
  .bg-image {
    z-index: -1;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
  }
  .result {
    background: #ffffff;
    border-radius: 8px;
    padding: 0px 20px 20px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title-image {
      height: 38px;
      margin-bottom: 14px;
    }
    .name {
      text-align: center;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: bold;
      font-size: 18px;
      color: #303038;
      line-height: 25px;
      margin-bottom: 16px;
    }
    .image {
      width: 150px;
      height: 150px;
      object-fit: contain;
    }
  }
  .tips {
    text-align: center;
    font-size: 12px;
    color: rgba(48, 48, 56, 0.5);
    line-height: 17px;
    margin-bottom: 20px;
  }
  .confirm-btn {
    height: 44px;
    background: #ff2270;
    border-radius: 22px;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: rgba(48, 48, 56, 1);
    }
  }
  .coach-container {
    box-sizing: border-box;
    padding: 8px 11px;
    z-index: 1;
    position: absolute;
    left: 50%;
    top: -30px;
    display: flex;
    align-items: center;
    width: 317px;
    transform: translateY(-100%) translateX(-50%);
    background: linear-gradient(
      90deg,
      rgba(5, 11, 39, 0.7) 0%,
      rgba(5, 11, 39, 0.3) 100%
    );
    border-radius: 62px;
    .coach-avatar {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
    }
    .coach-info {
      .name {
        white-space: nowrap;
        font-weight: bold;
        font-size: 14px;
        color: #fffcbd;
        line-height: 20px;
      }
      .desc {
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        line-height: 25px;
      }
      .text {
        font-weight: bold;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
}
</style>
